import React, { useEffect, useRef, useState, useContext} from 'react';
import { useOffers } from '../../hooks/useOffers';
import './Oferta.css';
import { Facebook } from 'react-spinners-css';
import { OfertaInvalida } from './OfertaInvalida';
import { OfertaError } from './OfertaError';
import { useServices } from '../../hooks/useServices';
import moment from 'moment';
import { OfertaListo2 } from './OfertaListo2';
import { OfertaNoVigente2 } from './OfertaNoVigente2';
import { OfertaYaActiva2 } from './OfertaYaActiva2';
import { usePayments } from '../../hooks/usePayments';
import { YaPago } from '../pago/YaPago';
import { tokenContext } from '../TokenContext';
import { Oferta001 } from './Oferta001';
import { useHistory } from 'react-router-dom';

export const OfertaMain = () => {

   
    const { activaSas, activaKairos} = useServices();

 
    // 001 —> Proceso de Activación
    // 002 —> No Vigente
    // 003 —> Activación Procesada
    // 004 —> Oferta Invalida
    // 005 —> Error

   
    const ref = useRef();
    const history = useHistory();
   
    const {consultaPay} = usePayments();
    const {loadpay , respuestaPayToken } =consultaPay;
    const {loaded , ofertas } = useOffers();
    

   // console.log('consultaPay: ',consultaPay);
    const miUrl = window.location.hostname;
    const port = window.location.port;
    const protocol = window.location.protocol;

    let reqLIC = {
        "dn":null,
        "financialAccount": "12345",
        "transactionExtId":"",
        "channelId":19,//canal ATT 18 - canal Unefon 19
        "chargeAmount":null,
        "ipAddress":"10.106.213.22",
        //"singlePaymentMethod":"",
        "paymentDetail":[
            {
                "detailId":0,//Es un consecutivo de la lista para identificar el pago
                "paymentTypeId":2,//tipo de pago el 2 es Tiempo Aire
                "unitPrice":null,
                "quantity":1,//Cantidad de Items adquiridos por tipo de pago
                "amount":null,//Monto del item seleccionado con IVA
                "percentageTax":16,//Se refiere al porcentaje del IVA a utilizar
                "saleOrder": null,
                "bluePackage": null,
                "compraAddOnVO": null,
                "order": null,
                "purchaseOfferRequest": null,
                "package": null
        }],
        "urlReturn":`${protocol}//${miUrl}:${port}/payment`,
        "customerId": null,//Identificador del cliente
        "token":""
    }

   


    if(loadpay){// esta cargando mientras responde el servicio de verificar pago
        if(respuestaPayToken != null && respuestaPayToken.data != null){//validar si la oferta esta registrada
                 const datosPago = respuestaPayToken.data;
                 console.log('verifica si ya pago: ', datosPago);
            if(datosPago.status_id === 3){// si esta pagada (3) lo mandamos a ya pago
                     ref.current = <YaPago {...datosPago}/>;
             }else{//si esta registrada pero no esta pagada (otro estatus, cancelada o error) pasa al flujo normal
                    if (loaded){
                        if (ofertas !== null){
                            const {data} = ofertas;
                            console.log('oferta: ', ofertas);
                            switch(ofertas.data.status) {
                                case "001":
                                            ref.current = <Oferta001 data1 ={data} lic={reqLIC} pag= {datosPago}/>;
                                break;
                                case "003":
                                            ref.current = <OfertaYaActiva2 data1 ={data} lic={reqLIC} pag= {datosPago}/>;
                                    
                                break;
                                case "002":
                                            ref.current = <OfertaNoVigente2 {...data}/>;
                                break;
                                case "004":
                                        ref.current = <OfertaInvalida {...data || ''}/>;
                                break;
                                default:
                                        if (ofertas.data.oferta) {
                                                ref.current = <OfertaListo2 data1 ={data} lic={reqLIC} pag={datosPago}/>;
                                                
                                        }else{
                                            ref.current = <OfertaError/>;
                                            console.log('error mostrando ofertas');
                                        }   
                                }
                            } else{
                                ref.current = <OfertaError/>;
                                console.log('error mostrando ofertas general');
                            } 
                        }
             }
     
        }else{//no esta registrada y pasa al flujo normal
              if (loaded){
                     const datosPago = respuestaPayToken;
                      if (ofertas !== null){
                             const {data} = ofertas;
                         switch(ofertas.data.status) {
                            case "001":
                                    ref.current = <Oferta001 data1 ={data} lic={reqLIC} pag= {datosPago}/>;
                             break;   
                             case "003":
                                         ref.current = <OfertaYaActiva2 data1 ={data} lic={reqLIC} pag= {respuestaPayToken.data}/>;
                                      
                                 break;
                                 case "002":
                                         ref.current = <OfertaNoVigente2 {...data}/>;
                                     
                                 break;
                                 case "004":
                                     ref.current = <OfertaInvalida {...data || ''}/>;
                                 break;
                                 default:
                                     if (ofertas.data.oferta) {
                                             ref.current = <OfertaListo2 data1 ={data} lic={reqLIC}/>;
                                          
                                     }else{
                                         ref.current = <OfertaError/>;
                                         console.log('error mostrando ofertas');
                                     }   
                             }
                         } else{
                             ref.current = <OfertaError/>;
                             console.log('error mostrando ofertas general');
                         } 
                }
            } 
    }
        
          
       

  
    return (
        <div className="contenedorPromociones">

            { loaded && loadpay
                ? <>
                    <div className="logoUnefon animate__animated animate__slideInLeft"></div>
                    {ref.current}

                    
                </>  
                : <div className="spinner"><Facebook color="#594498"/></div>
            }
        </div>
    )
}
